<template>
  <DsfFormControlBox class="ds-area-select" :owner="_self" >
    <template v-slot:simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props"></DsfTextProxy>
      <slot name="error">
        <div v-if="errors.length>0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
    <template v-slot:content>
      <!--只读状态只显示div-->
      <div v-if="readOnly" class="ds-form-readonly">
        <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false"></DsfTextProxy>
      </div>
      <!--非只读状态：级联-->
      <dsf-area-cascader
        v-else-if="showCascader"
        :value="value"
        class="ds-area-select-cascader"
        :placeholder="placeholder"
        :super-code="superCode"
        :range="range"
        :show-all-levels="showAllLevels"
        :check-strictly="checkStrictly"
        :post-has-alias="postHasAlias"
        :options-text-field="optionsTextField"
        :selected-text-field="selectedTextField"
        :disabled="disabled"
        :readonly="readOnly"
        @input="inputValue"
      />
      <slot name="error">
        <div v-if="errors.length>0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>

<script>
export default dsf.component({
  name: "DsfAreaSelect",
  mixins: [$mixins.formControl],
  ctrlCaption: "行政区划",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    formatter: {
      type: String,
      default: "textValue^text"
    },
    superCode: {
      type: [String, Number],
      default: "000000000000"
    },
    range: {
      type: Array,
      default() {
        return ["0", "4"];
      }
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("items-meta-data");
      }
    },
    // 输入框中是否显示选中值的完整路径
    showAllLevels: {
      type: Boolean,
      default: true
    },
    // 是否可选择任意一级
    checkStrictly: {
      type: Boolean,
      default: false
    },
    // 提交数据是否包含别名
    postHasAlias: {
      type: Boolean,
      default: false
    },
    // 选项中显示的文本字段
    optionsTextField: {
      type: String,
      default: "name"
    },
    //选中时显示的值
    selectedTextField: {
      type: String,
      default: "name"
    }
  },
  data() {
    return {
      isInit: false,
      options: {},
      showCascader: true,
    };
  },
  watch: {
    superCode() {
      this.showCascader = false;
      setTimeout(() => {
        this.showCascader = true;
      }, 20);
    }
  },
  methods: {
    inputValue(res) {
      this.emitValueChange(res);
      this.$nextTick(() => {
        this.emitFormValidate(res);
      });
    }
  },
  design: {
    layout: {
      exclude: ["value"]
    },
    metadata: {
      create(root) {
        let res = $mixins.formControl.design.metadata.create.call(this, root);
        let aliasIndex = _.findIndex(res.metadata.valueAttributes, (it) => it.code === "alias");
        if (this.postHasAlias && aliasIndex === -1) {
          res.metadata.valueAttributes.push({
            name: "别名",
            code: "alias",
            type: dsf.metadata.getDataType("string"),
            length: 100,
            defaultValue: null,
            encrypt: false,
            unit: null
          });
        } else if (!this.postHasAlias && aliasIndex > -1) {
          res.metadata.valueAttributes.splice(aliasIndex, 1);
        }
        return res;
      }
    }
  }
});
</script>